import { Data2, newId } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { Currency } from '../../../tables/types/types'
import { Discount } from '../../common'
import { useSystemStateHooks } from '../../system'
import { ProductPrices } from '../state/types'

export const useProductPricesBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildProductPrices = (data: Data2) => {
        const {
            id = newId(),
            productId,
            purchasePrice,
            vatTaxId,
            saleYield,
            bonuses
        } = data

        const prices: ProductPrices = {
            companyId: companyId!,
            id: id! as string,
            productId: productId! as string,
            purchasePrice: purchasePrice! as number,
            vatTaxId: vatTaxId! as string,
            saleYield: saleYield as O<number>,
            bonuses: (bonuses || []) as Discount[],
            currency: Currency.ARS
        }

        return prices
    }

    return {
        buildProductPrices
    }
}
